import { render, staticRenderFns } from "./RefsInputAccordion.vue?vue&type=template&id=f5be18bc&"
import script from "./RefsInputAccordion.vue?vue&type=script&lang=js&"
export * from "./RefsInputAccordion.vue?vue&type=script&lang=js&"
import style0 from "./RefsInputAccordion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports